import Vue from 'vue';
import Api from './BaseApi';
import { HTTP_DESKDAF } from '../plugins/axios';
/* eslint-disable */

class OrganizationApi extends Api {
  /**
   * The constructor for the OrganizationApi.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super(Vue.$http, 'organization', parameters);
    this.searchParameters = {};
  }

  /**
   * Method used to set the search parameters.
   *
   * @param {Object} param The given parameter.
   * @param {*} value The value to be set.
   *
   * @returns {Object} The instance of the OrganizationApi.
   */
  setSearchParam(param, value) {
    this.searchParameters[param] = value;
    return this;
  }

  /**
   * Method used to set the search parameters via an object.
   *
   * @param {Object} params The given parameter.
   *
   * @returns {Object} The instance of the OrganizationApi.
   */
  setSearchParamObject(params) {
    this.searchParameters = params;
    return this;
  }

  /**
   * Method used to fetch all items from the API.
   *
   * @returns {Promise} The result in a promise.
   */
  all() {
    const searchParameters = this.searchParameters;
    return this.submit('post', `/${this.endpoint}s`, searchParameters)
      .then(response => ({
        data: response.data.organizations,
        pagination: {
          limit: searchParameters.limit,
          totalCount: response.data.count,
          totalPages: Math.ceil(response.data.count / searchParameters.limit),
        },
      }));
  }

  deskDafOrganizations() {
    const searchParameters = this.searchParameters;
    return HTTP_DESKDAF.post(`/${this.endpoint}s`, searchParameters)
      .then(response => ({
        data: response.data.data.organizations,
        pagination: {
          limit: searchParameters.limit,
          totalCount: response.data.data.count,
          totalPages: Math.ceil(response.data.data.count / searchParameters.limit),
        },
      }));
  }

  createDeskDafOrganization(item) {
    return HTTP_DESKDAF.post(`/${this.endpoint}`, item)
  }

  findDeskDafOrganization(id) {
    return HTTP_DESKDAF.get(`/${this.endpoint}/${id}`);
  }

  updateOrg(organization){
    return Vue.$http.put(`/organization/${organization.id}`, organization);
  }

  getAllDomains() {
    return this.submit('post', `/${this.endpoint}s`, searchParameters)
      .then(response => ({
        data: response.data.organizations,
        pagination: {
          limit: searchParameters.limit,
          totalCount: response.data.count,
          totalPages: Math.ceil(response.data.count / searchParameters.limit),
        },
      }));
  }
}

export default new OrganizationApi();



// WEBPACK FOOTER //
// ./src/api/OrganizationApi.js